import SharedServicesImpl from "./shared_services_impl";

export default {
  cancelCompressJob: async (data) => {
    return SharedServicesImpl.cancelCompressJob(data);
  },
  updateAnalisysType: async (docId, data) => {
    return SharedServicesImpl.updateAnalisysType(docId, data);
  },
  getRetrieveAnnexes: async (data) => {
    return SharedServicesImpl.getRetrieveAnnexes(data);
  },
  getRetrieveUserCompressions: async () => {
    return SharedServicesImpl.getRetrieveUserCompressions();
  },
};
